import { Base64 } from 'js-base64';

const isExit = (value: string): boolean => {
  if (!value) return true;
  const btns: Array<any> = JSON.parse(sessionStorage.getItem('btns') || '');
  if (btns && btns.includes(Base64.encode(value))) return true;
  return false;
};

export {
  isExit,
};

export default {};
